/* eslint-disable no-unused-expressions,@typescript-eslint/no-unused-expressions */
import type {IAttributes, IAugmentedJQuery, IDocumentService, IParseService, IScope, IWindowService} from 'angular';
import {deepFreeze} from 'shared/utils/custom-utils';

const DEFAULT_OPTIONS: KpScrollUpDirectiveOptions = deepFreeze({
    topThreshold: 20,
    hiddenClass: 'ng-hide',
    visibleClass: ''
});

/**
 * @ngdoc directive
 * @name kpScrollUp
 * @module portaro.directives
 *
 * @param {KpScrollUpDirectiveOptions} kpScrollUp Options.
 *
 * @description
 * This directive adds described behaviour to decorated element.
 * On click, window scrolls up to top = 0.
 * It can be modified by options.
 *
 * @example
 * TODO
 */
export default class KpScrollUpDirective {
    public static directiveName = 'kpScrollUp';

    /*@ngInject*/
    constructor(private $document: IDocumentService, private $window: IWindowService, private $parse: IParseService) {
    }

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes) {
        let options: KpScrollUpDirectiveOptions = this.$parse($attrs[KpScrollUpDirective.directiveName])($scope) || {};

        options = Object.assign({}, DEFAULT_OPTIONS, options);

        const onScrollHandler = () => {
            if (this.$document[0].body.scrollTop > options.topThreshold || this.$document[0].documentElement.scrollTop > options.topThreshold) {
                $element[0].classList.contains(options.hiddenClass) && $element[0].classList.remove(options.hiddenClass);
                options.visibleClass && $element[0].classList.add(options.visibleClass);
            } else {
                options.hiddenClass && $element[0].classList.add(options.hiddenClass);
                $element[0].classList.contains(options.visibleClass) && $element[0].classList.remove(options.visibleClass);
            }
        };

        const onElementClickHandler = () => {
            this.$window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        };

        onScrollHandler();

        this.$window.addEventListener('scroll', onScrollHandler);
        $element[0].addEventListener('click', onElementClickHandler);

        $scope.$on('$destroy', () => {
            this.$window.removeEventListener('scroll', onScrollHandler);
            $element[0].removeEventListener('click', onElementClickHandler);

            $element[0].classList.remove('ng-hide');
        });
    }
}

/**
 * @ngdoc type
 * @name KpScrollUpDirectiveOptions
 * @module portaro.directives
 * 
 * @property {number} topThreshold Number in px. It defines scrollTop position for show button. Default is `20`.
 * @property {string} hiddenClass Class added to element if it is hidden.
 * @property {string} visibleClass Class added to element if it is visible.
 * 
 * @description
 * Options for {@link directive.kpScrollUp}
 */
export interface KpScrollUpDirectiveOptions {
    topThreshold?: number;
    hiddenClass?: string;
    visibleClass?: string;
}

/*
Suggested styles for scroll button:

.scroll-button {
  width: 50px;
  height: 50px;
  bottom: 20px;
  right: 30px;
  position: fixed;
  z-index: 99;
  background-color: red;
  cursor: pointer;
  opacity: 0.5;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scroll-button:hover {
    opacity: 1;
}

.scroll-button-hidden {
    display: none !important;
}
*/
